module.exports = __webpack_public_path__ + "img/nebula.211e98c8.svg";